import { isLocal } from "../utils/environment";

// throw an error if a main-thread object is used outside of the main thread
if (
  isLocal &&
  // eslint-disable-next-line no-eval
  "undefined" !== eval("typeof ServiceWorkerGlobalScope")
) {
  throw new Error("Main thread objects must not be used on the service worker");
}

export {};
